import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function NotFound() {
  useEffect(() => {
    document.title = "Stránka nenalezena | Daniel Pekař";
    const meta = document.head.querySelector('meta[name="robots"]');
    const prev = meta ? meta.getAttribute("content") : null;
    if (meta) meta.setAttribute("content", "noindex, nofollow");
    return () => {
      document.title = "Daniel Pekař – finanční poradce Ústí nad Labem";
      if (meta && prev) meta.setAttribute("content", prev);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-40 pb-24 px-6 text-center" data-testid="not-found-page">
        <p className="text-xs uppercase tracking-[0.25em] text-[#B69A58] font-medium">Chyba 404</p>
        <h1 className="font-display text-4xl md:text-5xl text-[#252525] mt-4">Tato stránka neexistuje</h1>
        <p className="text-[#737373] mt-4 max-w-md mx-auto">
          Omlouváme se, hledaná stránka nebyla nalezena. Zkuste se vrátit na úvod, nebo si domluvte konzultaci.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="px-6 py-3 border border-[#252525] text-[#252525] text-xs uppercase tracking-widest font-medium hover:bg-[#252525] hover:text-white transition-colors duration-300"
          >
            Zpět na úvod
          </Link>
          <a
            href="/#kontakt"
            data-testid="not-found-contact-link"
            className="text-xs uppercase tracking-widest font-medium text-[#B69A58] hover:text-[#8A6D2F] transition-colors duration-300"
          >
            Domluvit konzultaci
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
